import { useEffect, useRef, useState, useContext } from "react";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Popup from "../../components/popup/Popup";
import { MdNotificationsNone } from "react-icons/md";
import { Link } from "react-router-dom";
import {
  fetchDepositPending,
} from "../../store/actions";
import {
  showMessage,
  makeAjax,
  url,
  respStatus,
  logoutMe,
} from "../../helpers/global_helper";
import { fetchReferalInfo } from "../../store/actions";
import { useSelector, useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import HomeScreenPopup from "../../components/popup/popup-components/HomeScreenPopup";
import { HiMenuAlt1 } from "react-icons/hi";
import News from "../header/news/News";
import SideBar from "./sidebar/SideBar";
import NavigationCheck from "../../pages/utility/NavigationCheck";
import { SeoDymanicContent } from "../../pages/utility/SeoDymanicContent";
import ErrorBoundary from "../../helpers/ExceptionHandler/componentException";
import { ThemeModeContext } from "../../components/ThemeMode/Context";

const HeaderMobile = (props) => {
  const { userProfile } = useSelector((state) => ({
    userProfile: state.playerProfileR?.data ?? {},
  }));

  const [sideBar, setSideBar] = useState(false);
  const [popup, setPopup] = useState(window.location.pathname.split("/").pop() == "");
  const sideRef = useRef();
  const btnRef = useRef();
  const btnRefEmail = useRef();
  const [popupUnreadMessage, setPopupUnreadMessage] = useState(undefined);
  const [popupNotificationClosed, setPopupNotificationClosed] = useState(false);
  const [popupMessageId, setPopupMessageId] = useState(null);
  const [isNotification, setNotification] = useState(false);
  const [notificationCount, setNoticationCount] = useState(0);
  const [emailVer1, setEmailVer1] = useState(false);
  const [isComingSoon, setComingSoon] = useState(false);
  const [newMemoMessage, setNewMemoMessage] = useState(false);
  const [dismissedMessageId, setDismissedMessageId] = useState(null);
  const { themeMode, setThemeMode } = useContext(ThemeModeContext);
  const [emailVer, setEmailVer] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  let params = window.location.pathname.substring(1);
  let loggedIn = window.localStorage.getItem("user_token");
  const initAssetConfig = {
    width: 40,
    height: 40,
    alt: "defautl alt",
    description: "default description",
    image: "/assets/images/default-images/logo.svg",
    link: "",
  };
  // Set & get state
  const [assets, setAssets] = useState(initAssetConfig);
  const dispatch = useDispatch();
  const currentPath = window.location.pathname;

  const sideBarClose = () => {
    setSideBar(false);
    document.body.style.overflowY = "scroll";
  };
  const checkKeyStatus = (key) => {
    const storedDate = localStorage.getItem(key);

    if (storedDate == null) {
      return true;
    } else {
      const currentDate = new Date();
      const targetDate = new Date(storedDate);
      const timeDifferenceInHours =
        (currentDate - targetDate) / (1000 * 60 * 60);
      return timeDifferenceInHours > 24;
    }
  };

  const [isPopup, setIsPopup] = useState(false);
  const [isPopupReset, setIsPopupReset] = useState(false);
  const [mobileBeforeLogin, setMobileBeforeLogin] = useState(checkKeyStatus('pop_up_before_login'));
  const [mobileAfterLogin, setMobileAfterLogin] = useState(checkKeyStatus('pop_up_after_login'));

  const { componentSetting } = useSelector((state) => ({
    componentSetting: state.componentSettingListR.data,
  }));

  const handlePopupCheckbox = (isPopupEnabled) => {
    const currentDate = new Date().toISOString();
    const key =
      loggedIn == false || loggedIn == null
        ? "pop_up_before_login"
        : "pop_up_after_login";
    if (isPopupEnabled) {
      localStorage.setItem(key, currentDate);
    } else {
      localStorage.removeItem(key);
    }
  };

  const handlePopup = () => {
    setPopup(false);
    setIsPopup(false);
    setNotification(false);
    setMobileBeforeLogin(false);
    setMobileAfterLogin(false);
  };

  const resetHandlePopup = () => {
    setIsPopupReset(false);
  };

  const loginPopupTrigger = () => {
    setIsPopup(true);
  };

  const messageRead = (messageId = null) => {

    console.log('on click inside mobile view messageRead');
    localStorage.setItem("msssssss","on click inside mobile view messageRead");

    if (messageRead != null) {
      console.log('inside on click inside mobile view messageRead');
      localStorage.setItem("msssssss", "inside on click inside mobile view messageRead");
      const payload = { _id: popupMessageId };
      if (messageId) {
        payload['_id'] = messageId;
      }

      makeAjax(
        url.MEMO_API.updatePopupMessageStatus,
        payload,
        url.MEMO_MS_EXT
      ).then((response) => {
        if (response.status !== respStatus.SUCCESS) {
          showMessage(response);
          return;
        }

        setPopupNotificationClosed(true);
        dispatch(fetchDepositPending());

        if (messageId) {
          window.close();
        }

        if (currentPath === "/transaction-queue") {
          navigate("/withdraw");
        }
      });
    }
  };

  useEffect(() => {
    function handler(e) {
      if (
        !sideRef.current?.contains(e.target) &&
        !btnRef.current?.contains(e.target)
      ) {
        setSideBar(false);
        document.body.style.overflowY = "scroll";
      }
    }
    document.body.addEventListener("click", handler);
    return () => document.body.removeEventListener("click", handler);
  }, []);

  useEffect(() => {
    const timeout = setInterval(() => {
      setEmailVer1(false);
    }, 5000);
    return () => {
      clearInterval(timeout);
    };
  }, []);

  const updateLastLoginAt = () => {
    if (!userProfile.username) return;
    makeAjax(url.USER_API.lastActiveAt, [], url.USER_MS_EXT).then(
      (response) => {
        if (response.status != respStatus["SUCCESS"]) {
          showMessage(response);
          return;
        }
      }
    );
  };

  useEffect(() => {
    if (loggedIn != "" && loggedIn != null) {
      updateLastLoginAt();
      const interval1 = setInterval(() => updateLastLoginAt(), 60000);
      return () => {
        clearInterval(interval1);
      };
    }
  }, [userProfile]);

  const hamburgerClick = () => {
    setSideBar(true);
    document.body.style.overflow = "hidden";
  };

  const [userDataHandleClick, setUserDataHandleClick] = useState(false);

  const userDataHandle = () => {
    setUserDataHandleClick(true);
  };

  useEffect(() => {
    dispatch(fetchReferalInfo("mobile"));
    function handlerEmail(e) {
      if (!btnRefEmail.current?.contains(e.target)) {
        setEmailVer(false);
      }
    }
    document.body.addEventListener("click", handlerEmail);
    return () => document.body.removeEventListener("click", handlerEmail);
  }, []);

  // Fetch other media
  const { otherMedia } = useSelector((state) => ({
    otherMedia: state.othermediaInformationListR.data,
  }));

  // Effect call for manupulate data
  useEffect(() => {
    setAssets(initAssetConfig);
    // Width
    if (
      typeof otherMedia["logo"] != "undefined" &&
      typeof otherMedia["logo"][0] != "undefined" &&
      typeof otherMedia["logo"][0]["width"] != "undefined"
    ) {
      assets["width"] = otherMedia["logo"][0]["width"];
      setAssets({
        ...assets,
      });
    }

    // Heigth
    if (
      typeof otherMedia["logo"] != "undefined" &&
      typeof otherMedia["logo"][0] != "undefined" &&
      typeof otherMedia["logo"][0]["height"] != "undefined"
    ) {
      assets["height"] = otherMedia["logo"][0]["height"];
      setAssets({
        ...assets,
      });
    }

    // Description
    if (
      typeof otherMedia["logo"] != "undefined" &&
      typeof otherMedia["logo"][0] != "undefined" &&
      typeof otherMedia["logo"][0]["description"] !=
      "undefined"
    ) {
      assets["description"] =
        otherMedia["logo"][0]["description"];
    }

    // alternative
    if (
      typeof otherMedia["logo"] != "undefined" &&
      typeof otherMedia["logo"][0] != "undefined" &&
      typeof otherMedia["logo"][0]["alternate"] !=
      "undefined"
    ) {
      assets["alt"] = otherMedia["logo"][0]["alternate"];
      setAssets({
        ...assets,
      });
    }

    // Image path
    if (
      typeof otherMedia["logo"] != "undefined" &&
      typeof otherMedia["logo"][0] != "undefined" &&
      typeof otherMedia["logo"][0]["path"] != "undefined"
    ) {
      assets["image"] = otherMedia["logo"][0]["path"];
      setAssets({
        ...assets,
      });
    }

    if (
      typeof otherMedia["logo"] != "undefined" &&
      typeof otherMedia["logo"][0] != "undefined" &&
      typeof otherMedia["logo"][0]["link"] != "undefined"
    ) {
      assets["link"] = otherMedia["logo"][0]["link"];
      setAssets({
        ...assets,
      });
    }
  }, [otherMedia]);

  useEffect(() => {
    if (loggedIn && popupNotificationClosed === false) {
      unreadPopUpMessages();
      getNotificationCount();

      const interval = setInterval(() => {
        if (!popupNotificationClosed) unreadPopUpMessages();
      }, 6000);

      return () => clearInterval(interval);
    }
  }, [loggedIn, popupNotificationClosed]);;

  let tempPayload = {
    location,
    navigate,
  };

  useEffect(() => {
    if (loggedIn != "" && loggedIn != null) {
      // getPinStatus();
      NavigationCheck(tempPayload, "headerMobile");
    }
  }, [loggedIn && params]);

  const unreadPopUpMessages = () => {
    if (popupNotificationClosed) return;
    makeAjax(url.MEMO_API.getUnreadPopUpMessage, [], url.MEMO_MS_EXT).then(
      (response) => {
        if (response.status != respStatus["SUCCESS"]) {
          showMessage(response);
          return;
        }

        setPopupUnreadMessage(response?.data);
        if (response.data != null) {
          const messageId = response?.data?._id;
          if (messageId === dismissedMessageId) return;

          if (response?.data?.notification_type == "deposit" && localStorage.getItem("hkb_provider_deposit")) {
            localStorage.removeItem("hkb_provider_deposit");
            setPopupMessageId(messageId);
            messageRead(messageId);
            return;
          }

          if (messageId && response?.data?.popup_message == "memo") {
            setNewMemoMessage(true);
          } else {
            setPopupNotificationClosed(true);
          }
          setPopupMessageId(response?.data?._id);
        }
      }
    );
  };





  const handleNotificationPopup = () => {
    messageRead();
    setPopupNotificationClosed(false);
    setPopupMessageId(null);
    setNewMemoMessage(false);
    setNotification(false);
    setPopupUnreadMessage(undefined);
    setDismissedMessageId(popupMessageId)
  };


  const getNotificationCount = () => {
    makeAjax(
      url.MEMO_API.getPlayerUnreadMessageCount,
      [],
      url.MEMO_MS_EXT
    ).then((response) => {
      if (response.status != respStatus["SUCCESS"]) {
        showMessage(response);
        return;
      }
      setNoticationCount(response.data);
    });
  };

  const NavLink = React.forwardRef(({ href, children, ...rest }, ref) => (
    <Link ref={ref} to={href} {...rest}>
      {children}
    </Link>
  ));

  useEffect(() => {
    if (loggedIn != null) {
      getNotificationCount();
    }
  }, []);

  const logout = () => {
    logoutMe();
  };

  //mobile popup image hide
  useEffect(() => {
    const checkMobilePopupStatus = (key, setFunction) => {
      const storedDate = localStorage.getItem(key);

      if (storedDate == null) {
        setFunction(true);
      } else {
        const currentDate = new Date();
        const targetDate = new Date(storedDate);
        const timeDifferenceInHours =
          (currentDate - targetDate) / (1000 * 60 * 60);
        setFunction(timeDifferenceInHours > 24);
      }
    };
    // Check before login popup status (24-hour threshold)
    if (loggedIn == false || loggedIn == null) {
      checkMobilePopupStatus(
        "pop_up_before_login",
        setMobileBeforeLogin
      );
    } else {
      // Check after login popup status (24-hour threshold)
      checkMobilePopupStatus("pop_up_after_login", setMobileAfterLogin);
    }

  }, []);

  const handlePopupCommingSoon = () => {
    setComingSoon(!isComingSoon);
  };
  return (
    <>
      <header className="header-mobile background-mobile_header">
        <div className="d-flex align-content-center">
          <span
            className={`hamburger ${sideBar && "click"}`}
            ref={btnRef}
            onClick={hamburgerClick}
          >
            <HiMenuAlt1 />
            <SeoDymanicContent payload={'seo'} />
          </span>

          {typeof componentSetting?.["top-nav-logo"] != "undefined" &&
            componentSetting?.["top-nav-logo"]?.["default-value"] && (
              <Link
                to={assets["link"] ? assets["link"] : "/"}
                className="header-mlogo"
              >
                <span>
                  <img
                    loading="lazy"
                    className=""
                    src={assets["image"]}
                    alt={assets["alt"]}
                    width={assets["width"]}
                    height={assets["height"]}
                  />
                </span>
              </Link>
            )}
        </div>
        {loggedIn != null && loggedIn != "" && userProfile.username ? (
          <div className="user-info">
            {notificationCount > 0 ? <div className="red-dot"></div> : ""}
            <div
              className="notification-icon"
              onClick={() => setNotification(true)}
            >
              <MdNotificationsNone />
            </div>

            {/* <Dropdown data-bs-theme="dark">
              <Dropdown.Toggle className="user-icon">
                {userProfile.username
                  ? userProfile.username[0].toUpperCase()
                  : "U"}
              </Dropdown.Toggle>
              {!userProfile.email_verified_at && (
                <div className="red-dot1"></div>
              )}
              <Dropdown.Menu>
                <Dropdown.Item as={NavLink} href="/profile" active>
                  <BiUser className="header-proicons" />
                  <span>
                    {props.t("profile")}
                    {!userProfile.email_verified_at && (
                      <div className="red-dot1"></div>
                    )}
                  </span>
                </Dropdown.Item>
                <Dropdown.Item>
                  <a onClick={() => setIsPopupReset(!isPopupReset)}>
                    <CgPassword className="header-proicons" />
                    <span>{props.t("reset_password")}</span>
                  </a>
                </Dropdown.Item>
                <Dropdown.Item onClick={logout} as={NavLink} href="/">
                  {" "}
                  <TbLogout className="header-proicons" />
                  <span>{props.t("log_out")}</span>
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown> */}
          </div>
        ) : (
          <div className="d-flex gap-2">
            {!loggedIn && typeof componentSetting?.["top-nav-login-box"] != "undefined" &&
              componentSetting?.["top-nav-login-box"]?.["default-value"] && (
                <>
                  <a
                    className="login-gray-btn text_button-mobile_login text-mobile_login border-mobile_login background-mobile_login_button"
                    onClick={() => setIsPopup(true)}
                  >
                    {props.t("login")}{" "}
                  </a>
                  <NavLink to="register" className="purple-btn text_button-mobile_register text-mobile_register border-mobile_register background-mobile_register_button">
                    {props.t("register")}
                  </NavLink>
                </>
              )}
          </div>
        )}
      </header>

      {typeof componentSetting?.["mobile_sidebar_menu_listing"] !=
        "undefined" && (
          <SideBar
            sideRef={sideRef}
            sideBar={sideBar}
            sideBarClose={sideBarClose}
            loginPopupTrigger={loginPopupTrigger}
            userDataHandleClick={userDataHandleClick}
            handlePopup={
              props?.handleClose ? props?.handleClose : handlePopupCommingSoon
            }
          />
        )}

      {isPopup && (
        <Popup
          handlePoup={handlePopup}
          // loginMobile
          loginpopup
          userDataHandle={userDataHandle}
        />
      )}
      {/* {typeof componentSetting?.["news"] != "undefined" &&
        componentSetting?.["news"]?.["default-value"] && <ErrorBoundary><News /></ErrorBoundary>} */}
      <News />
      {popup &&
        userProfile.username &&
        mobileAfterLogin &&
        otherMedia?.["pop_up_after_login"]?.[0]?.[
        "image_status"
        ] && (
          <div className="homepage-popup">
            <Popup
              handlePoup={handlePopup}
              handlePopupCheckbox={handlePopupCheckbox}
              afterLogin
            />
          </div>
        )}

      {popup &&
        !userProfile.username &&
        mobileBeforeLogin &&
        otherMedia?.["pop_up_before_login"]?.[0]?.[
        "image_status"
        ] && (
          <div className="homepage-popup">
            <Popup
              handlePoup={handlePopup}
              handlePopupCheckbox={handlePopupCheckbox}
              beforeLogin
            />
          </div>
        )}

      {isPopupReset && <Popup handlePoup={resetHandlePopup} changePass />}

      {isNotification && (
        <Popup
          handlePoup={handlePopup}
          length={notificationCount}
          getNotificationCount={getNotificationCount}
          readNotification
        />
      )}

      {popupUnreadMessage && popupUnreadMessage != undefined &&
        popupUnreadMessage != "undefined" && 
        popupUnreadMessage != null &&
        popupUnreadMessage != 'null' &&
        popupNotificationClosed &&
        loggedIn && (
          <HomeScreenPopup
            handlePopup={handleNotificationPopup}
            popupNotificationClosed={popupNotificationClosed}
            data={popupUnreadMessage}
            setNotification={setNotification}
            messageRead={messageRead}
          />
        )}
      {isComingSoon && <Popup handlePoup={handlePopupCommingSoon} comingSoon />}
      <>
        {popupUnreadMessage && popupUnreadMessage != undefined &&
          popupUnreadMessage != "undefined" &&
          popupUnreadMessage != null &&
          popupUnreadMessage != "null" && 
          newMemoMessage && loggedIn && (
            <Popup
              handleMemoPopup={handleNotificationPopup}
              newMemoMessage
              length={notificationCount}
              setNotification={setNotification}
              getNotificationCount={getNotificationCount}
            />
          )}
      </>
    </>
  );
};

HeaderMobile.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
};

export default withTranslation()(HeaderMobile);
